export const ACTION_LABELS: Record<string, string> = {
  contact_processing: 'Contact extraction',
  contact_extraction: 'Contact extraction', // legacy
  smart_notes: 'Smart Notes',
  smart_notes_research: 'Smart Notes',
  topup: 'Top-up purchase',
  topup_purchase: 'Top-up purchase',
  subscription_purchase: 'Subscription purchase',
  subscription_renewal: 'Subscription renewal',
  subscription_cancelled: 'Subscription cancelled',
  subscription_grant: 'Subscription credits',
  welcome_bonus: 'Welcome bonus',
  review_reward: 'Review reward',
  admin_grant: 'Admin adjustment',
  manual_grant: 'Manual grant',
  auto_refund: 'Automatic refund',
  error_refund: 'Manual refund',
  plan_renewal_expiration: 'Renewal expiration',
  plan_change_expiration: 'Plan change expiration',
  grace_period_expiration: 'Grace period expiration',
};

export function formatActionLabel(actionType: string): string {
  if (!actionType) return '—';
  return (
    ACTION_LABELS[actionType] ??
    actionType.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  );
}

export function formatReason(
  meta: any,
  actionType: string,
  _transactionId?: string
): string {
  if (meta?.reason) return String(meta.reason);
  if (meta?.type) return String(meta.type);

  switch (actionType) {
    case 'contact_processing':
    case 'contact_extraction':
      return 'Email → contact extraction';
    case 'smart_notes':
    case 'smart_notes_research':
      return 'Smart Notes research';
    case 'welcome_bonus':
      return 'Account signup bonus';
    case 'auto_refund':
      return 'Automatic refund after error';
    case 'error_refund':
      return 'Admin refund for reported error';
    case 'topup':
    case 'topup_purchase':
      return meta?.package ? `${meta.package} top-up purchase` : 'Top-up purchase';
    case 'subscription_renewal':
      return 'Monthly subscription renewal';
    case 'subscription_purchase':
      return 'Subscription purchase';
    case 'subscription_cancelled':
      return 'Subscription cancelled';
    case 'subscription_grant':
      return 'Subscription credits granted';
    case 'plan_renewal_expiration':
      return 'Unused credits expired on renewal';
    case 'plan_change_expiration':
      return 'Credits expired on plan change';
    case 'grace_period_expiration':
      return 'Grace period ended';
    case 'review_reward':
      return 'Thanks for your review';
    case 'admin_grant':
      return 'Admin adjustment';
    case 'manual_grant':
      return 'Manual grant';
    default:
      return formatActionLabel(actionType);
  }
}
